import { Router } from '@angular/router';
import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from '@services/toaster.service';
import { GenericApiService } from '@services/generic-api.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { MatToolbar } from '@angular/material/toolbar';
import { LoaderModule } from '@mds/ui';

@Component({
  selector: 'app-knowledge-base',
  templateUrl: './knowledge-base-dialog.component.html',
  imports: [MatToolbar, MatDialogContent, LoaderModule],
  styleUrls: ['./knowledge-base-dialog.component.scss'],
})
export class KnowledgeBaseDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private router: Router,
    private toastrService: ToastrService,
    private dialogRef: MatDialogRef<KnowledgeBaseDialogComponent>,
    private genericApiService: GenericApiService
  ) {}

  ngOnInit(): void {
    this.genericApiService
      .linkApiCall('post', this.data.path, this.data.body)
      .subscribe(
        (res: any) => {
          if (res.redirect_to) window.open(res.redirect_to);
          else this.router.navigate(['dashboard']);
          this.closeDialog();
        },
        (error) => {
          this.toastrService.show(
            error.error?.message ||
              error.message ||
              'Error occurred while authenticating',
            3000
          );
          this.router.navigate(['dashboard']);
          this.closeDialog();
        }
      );
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
